import { useQuery } from '@tanstack/react-query';
import { ContentType } from 'api/contentful/contentTypes.cloverdotcom';
import { IContentfulFilters } from 'api/contentful/fetchEntries';
import { useTranslation } from 'react-i18next';
import { ONE_HOUR_IN_MS } from 'globalConstants';
import { fetchFlatEntries } from 'utils/fetchFlatEntries';

export function useAllContentfulEntries<T extends object>(
  contentType: ContentType,
  filter: IContentfulFilters = {},
) {
  const { language } = useTranslation().i18n;

  return useQuery(
    [contentType, `${JSON.stringify(filter)}`],
    () => fetchFlatEntries<T>(language, { ...filter, contentType }),
    {
      staleTime: ONE_HOUR_IN_MS,
    },
  );
}
